import { render, staticRenderFns } from "./wechatDetailModal.vue?vue&type=template&id=71b07bf9&scoped=true"
import script from "./wechatDetailModal.vue?vue&type=script&lang=js"
export * from "./wechatDetailModal.vue?vue&type=script&lang=js"
import style0 from "./wechatDetailModal.vue?vue&type=style&index=0&id=71b07bf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b07bf9",
  null
  
)

export default component.exports